import React, { useEffect } from 'react';
import { cn } from '@/utils/cn';
import { PHONE, EMAIL, TEXT_COLOR_MODE } from '@/constants';
import { useDispatch, useSelector } from 'react-redux';
import { setLoginErrorMessage } from '@/redux/reducers/auth-reducer';
import Text from '../Text';
import Icon from '../Icon';
import Button from '../Button';

function InputTypeTab({ activeTab, setActiveTab, resetField }) {
  const dispatch = useDispatch();

  const { colorSchema } = useSelector((state) => state.globalSettings);

  useEffect(() => {
    resetField();
  }, [activeTab]);

  return (
    <div className="flex justify-center mb-28">
      <div className="w-full !h-[40px] max-w-[247px] flex flex-nowrap rounded-[100px] border border-senate">
        <Button
          type="primary"
          className={cn(
            'min-w-[80px]  bg-white text-richcarmine !py-8 !px-24 rounded-[100px] gap-[10px] ',
            activeTab === PHONE &&
              '!bg-richcarmine !font-bold border border-richcarmine',
          )}
          onClick={() => {
            setActiveTab(PHONE);
            dispatch(setLoginErrorMessage(''));
          }}
        >
          <div className="w-[24px] h-[24px]">
            <Icon
              type="phone"
              color={
                activeTab === PHONE ? TEXT_COLOR_MODE[colorSchema] : '#db0032'
              }
              width="24px"
              height="24px"
            />
          </div>

          <Text
            type="paragraph"
            className={cn(
              'text-16 text-richcarmine font-encode-sans font-normal leading-20 tracking-[0.32px]',
              activeTab === PHONE && '!text-white !font-semibold',
            )}
          >
            Phone
          </Text>
        </Button>
        <Button
          type="primary"
          className={cn(
            'min-w-[80px]  bg-transparent !py-8 !px-24 rounded-[100px] gap-[10px] text-16',
            activeTab === EMAIL && '!bg-richcarmine !text-white',
          )}
          onClick={() => {
            setActiveTab(EMAIL);
            dispatch(setLoginErrorMessage(''));
          }}
        >
          <div className="w-[24px] h-[24px]">
            <Icon
              type="email"
              color={activeTab === EMAIL ? '#FFF' : null}
              height="24px"
              width="24px"
            />
          </div>

          <Text
            type="paragraph"
            className={cn(
              'text-16 text-richcarmine font-encode-sans font-normal leading-20 tracking-[0.32px]',
              activeTab === EMAIL && '!text-white !font-semibold',
            )}
          >
            Email
          </Text>
        </Button>
      </div>
    </div>
  );
}

export default InputTypeTab;
